import React from 'react';
import ReactDOM from 'react-dom';
import { IdProvider } from 'react-use-id-hook';

import { DocumentProvider } from './context/document';
import { SessionProvider } from './context/session';
import { WebsocketsProvider } from './context/websockets';
import ChatPopup from './components/Chat/Popup';

import './styles/app.scss';

function App() {
    return <>
        <IdProvider>
            <DocumentProvider>
                <SessionProvider>
                    <WebsocketsProvider>
                        <ChatPopup />
                    </WebsocketsProvider>
                </SessionProvider>
            </DocumentProvider>
        </IdProvider>
    </>;
}

ReactDOM.render(<App />, document.getElementById('chat-app'));
